var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinRaingg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#:r25:coin_svg__a)",
    d: "M15.907 7.433c-.587-3.567-3.904-6.3-7.907-6.3S.68 3.867.093 7.434H0v1.134C0 12.672 3.582 16 8 16s8-3.328 8-7.433V7.433z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#:r25:coin_svg__b)",
    d: "M8 14.866c4.418 0 8-3.328 8-7.433S12.418 0 8 0 0 3.328 0 7.433s3.582 7.433 8 7.433"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#:r25:coin_svg__c)",
    d: "M8 13.372c3.53 0 6.392-2.66 6.392-5.939S11.53 1.494 8 1.494s-6.392 2.66-6.392 5.94c0 3.279 2.862 5.938 6.392 5.938"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#:r25:coin_svg__d)",
    d: "M8 2.116c3.418 0 6.21 2.492 6.383 5.628q.009-.155.009-.31c0-3.28-2.862-5.94-6.392-5.94s-6.392 2.66-6.392 5.94q0 .155.01.31C1.79 4.608 4.581 2.116 8 2.116"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#:r25:coin_svg__e)",
    d: "M4.754 7.943c-.213-.029-.417-.222-.374-.44l.047-.203a.5.5 0 0 1 .053-.151c.061-.1.156-.147.293-.16l1.085-.161c1.87-.138 1.672-1.044 1.946-1.744l.432-1.294c.038-.175.146-.274.336-.274H8.9c.19 0 .289.1.251.274l-.076 1.318c-.095 1.04.01 1.507 1.085 1.653l1.18.236s.331.053.284.345l-.07.33a.29.29 0 0 1-.29.241l-1.155.147c-1.09.099-1.384-.015-1.743 1.313L7.9 11.03c-.024.174-.147.274-.337.274h-.46c-.189 0-.279-.1-.25-.274l.133-1.616c.057-1.034-.313-1.185-1.217-1.308l-1.019-.17.005.005h-.002Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: ":r25:coin_svg__a",
    x1: 3.56,
    x2: 16.483,
    y1: -1.567,
    y2: 29.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: ":r25:coin_svg__b",
    x1: 3.321,
    x2: 25.312,
    y1: 2.84,
    y2: 24.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: ":r25:coin_svg__c",
    x1: 14.393,
    x2: -17.887,
    y1: -33.321,
    y2: 60.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: ":r25:coin_svg__d",
    x1: 3.887,
    x2: 16.441,
    y1: 21.299,
    y2: -5.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D1903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: ":r25:coin_svg__e",
    x1: 0.37,
    x2: 13.38,
    y1: 26.283,
    y2: -9.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3406"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinRaingg);
export default __webpack_public_path__ + "static/media/coinRAINGG.e5aef293ec6414366076964e74058e01.svg";
export { ForwardRef as ReactComponent };